export class SecurityQuestionData {
    private sequrityQuestionsList: string[] = ["What is your favotite car?", "What is your city of Birth?", "What is your favorite football team?"];
    public getQuestionsList(): Array<string> {
        return this.sequrityQuestionsList;
    }
}